import Layout from "../components/layout/Layout";
import MessageCalendarSettings from "../components/page/MessageCalendarSettings";

const MessageCalendarPage = () => {
  return (
      <Layout>
          <MessageCalendarSettings />
      </Layout>
  );
};
export default MessageCalendarPage;
